<app-page-layout>
    <sh-breadcrumbs breadcrumbs>
        <sh-breadcrumb-item [label]="'common.general.home' | translate" href="/"></sh-breadcrumb-item>
    </sh-breadcrumbs>

    <h1 title class="text-3xl text-shui-text-strong m-0 p-0 select-none font-sh-bree-headline">
        {{ 'menu.title' | translate }}
    </h1>

    <div class="grid grid-cols-[repeat(auto-fill,320px)] gap-4 w-full flex-1 min-h-0 mt-4">
        <sh-card
            [label]="'menu.cards.my-requests.title' | translate"
            icon="comment"
            [routerLink]="isTaskOwner() ? '/tasks' : '/requests'"
            image="/assets/images/menu/my-requests.jpg"
            class="h-72"
        >
            {{ 'menu.cards.my-requests.description' | translate }}
        </sh-card>

        <sh-card
            [label]="'menu.cards.initial-reagent-order.title' | translate"
            icon="samples"
            [routerLink]="'/request'"
            image="/assets/images/menu/iro.png"
            class="h-72"
        >
            {{ 'menu.cards.initial-reagent-order.description' | translate }}
        </sh-card>
    </div>
</app-page-layout>
